import { render, staticRenderFns } from "./company_address.vue?vue&type=template&id=54132f44&scoped=true"
import script from "./company_address.vue?vue&type=script&lang=js"
export * from "./company_address.vue?vue&type=script&lang=js"
import style0 from "./company_address.vue?vue&type=style&index=0&id=54132f44&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "54132f44",
  null
  
)

export default component.exports